import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { UpdateInvoice } from "../../../components/Reports/Update Invoice";

export interface IUpdateInvoiceAdminPage {}

export const UpdateInvoiceAdminPage: FC<IUpdateInvoiceAdminPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Update Invoice"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<UpdateInvoice />}
    />
  );
};
